import React from 'react'
import PropTypes from 'prop-types'
import TweetField from 'pages/widgets/form/tweet-input'

export const TriggerBlastField = ({ name }) => (
  <div>
    <div className='form-group checkGroup' style={{ marginRight: '0' }}>
      <div className='col-md-12 no-padding-right'>
        <TweetField
          isTriggerBlast
          messageName={`${name}.message`}
          urlName={`${name}.attachmentUrl`}
          cardUriName={`${name}.cardUri`}
        />
      </div>
    </div>
  </div>
)

TriggerBlastField.propTypes = {
  name: PropTypes.string
}

export default TriggerBlastField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/trigger-blast/index.js